import axios from 'axios'

const VerificarGeradoresPersonalizadosDuplicados = (products) => {
  if (products.length === 1) return []

  const productsStrings = products.map((m) => {
    const { id, ...rest } = m
    return { id, values: JSON.stringify(rest) }
  })

  const duplicates = productsStrings
    .filter((f) => {
      return !!productsStrings.find((f2) => f2.id !== f.id) && !!productsStrings.find((f2) => f2.values === f.values)
    })
    .map((m) => JSON.parse(m.values).Descricao)

  return duplicates
}

const NormalizarInsumos = (produtoInsumos) => {
  const novosInsumos = produtoInsumos.map((m) => ({ ...m, Associados: m.Associados.map((y) => ({ ...y })) }))
  const novosInsumosAssociados = novosInsumos
    .filter((f) => f.Associados && f.Associados.length > 0)
    .map((m) => m.Associados[0])
    .reduce((associados, associado) => {
      const existenteInsumo = novosInsumos.filter((f) => f.Codigo === associado.Codigo)

      if (existenteInsumo.length > 0) {
        existenteInsumo[0].Quantidade += associado.Quantidade
        existenteInsumo[0].Valor += associado.Valor
      } else {
        let existenteAssociado = associados.filter((f) => f.Codigo === associado.Codigo)

        if (existenteAssociado.length > 0) {
          existenteAssociado[0].Quantidade += associado.Quantidade
          existenteAssociado[0].Valor += associado.Valor
        } else {
          associados.push(associado)
        }
      }

      return associados
    }, [])

  return [...novosInsumos, ...novosInsumosAssociados]
}

const GetPedidoVendaDireta = ({ apiUrl, codigoPedido }) =>
  axios.post(`${apiUrl}/Carrinho.svc/GetPedidoVendaDireta`, { codigoPedido }, { withCredentials: true }).then((res) => res.data)

const AddCustomProduct = async (apiUrl, data) =>
  await axios.post(`${apiUrl}/Produto.svc/ConfirmarPersonalizacao`, data, { withCredentials: true }).then((res) => res.data)

const AlterarTransportadora = async (apiUrl, data) =>
  await axios.post(`${apiUrl}/Carrinho.svc/AlterarTransportadora`, data, { withCredentials: true }).then((res) => res.data)

const AlterarTipoPagamento = async (apiUrl, data) => {
  try {
    if (!!data && !!data.cdCliente) {
      const response = await axios.post(`${apiUrl}/Carrinho.svc/AlterarTipoPagamento`, data, { withCredentials: true })
      return response.data
    }
  } catch (error) {
    return error
  }
}

const ComissaoDoPedidoVendaDireta = async (apiUrl, codigoPedido) =>
  await axios.post(`${apiUrl}/Carrinho.svc/ComissaoDoPedidoVendaDireta`, { codigoPedido }, { withCredentials: true }).then((res) => res.data)

const ValidaZeroICMS = async (apiUrl) => await axios.get(`${apiUrl}/Carrinho.svc/ValidaZeroICMS`, { withCredentials: true }).then((res) => res.status)

const CarregarFormulario = async (apiUrl, codigoPedidoInformado, orcamento) =>
  await axios
    .post(`${apiUrl}/Carrinho.svc/CarregarFormulario`, { codigoPedidoInformado, orcamento }, { withCredentials: true })
    .then((res) => res.data)

const DuplicarProdutos = async (apiUrl, data) =>
  await axios.post(`${apiUrl}/Produto.svc/DuplicarProduto`, data, { withCredentials: true }).then((res) => res.data)

const AlterarProposta = async (apiUrl, prjCodigo, data) =>
  await axios.post(`${apiUrl}/Projeto.svc/projeto/${prjCodigo}/editar-produto`, data, { withCredentials: true }).then((res) => res.data)

const GetParcelasPgtoPrazo = async (apiUrl, data) =>
  await axios.post(`${apiUrl}/Carrinho.svc/GetLoadPrazoPagamentoParcelas`, data, { withCredentials: true }).then((res) => res.data)

export default {
  DuplicarProdutos,
  NormalizarInsumos,
  GetPedidoVendaDireta,
  AddCustomProduct,
  AlterarTransportadora,
  AlterarTipoPagamento,
  ComissaoDoPedidoVendaDireta,
  ValidaZeroICMS,
  CarregarFormulario,
  VerificarGeradoresPersonalizadosDuplicados,
  GetParcelasPgtoPrazo,
  AlterarProposta,
}
